export function gen_rank_list(container_id, level, data) {
    const cur_div = document.getElementById(container_id);
    let ul = document.createElement('ul');
    ul.className = 'list-group';

    for (const [idx, item] of data.entries()) {
        // parse data
        let title = item.title;
        let views = item.tracking;
        let name = item.name
        let url = `https://data.depositar.io/${level}/${name}`

        // generate single entry
        let li = document.createElement('li');
        li.className = 'list-group-item d-flex justify-content-between align-items-center';
        
        let a = document.createElement('a');
        a.className = 'text-link';
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.href = url
        a.innerHTML = `${title} <i class="bi bi-box-arrow-up-right"></i>`
        //a.textContent = `${title} (depositar <i class="bi bi-box-arrow-up-right"></i>)`

        let span = document.createElement('span')
        if(idx == 0) {
            span.className = 'badge bg-danger rounded-pill'
        } else if (idx == 1 || idx == 2) {
            span.className = 'badge bg-warning rounded-pill'
        } else {
            span.className = 'badge bg-primary rounded-pill'
        }
        
        span.textContent = views

        li.appendChild(a)
        li.appendChild(span)

        // append entry to ul
        ul.appendChild(li)
    }
    cur_div.appendChild(ul)
}

